import {
  WORKSHOP_REGISTRATION_STATUS_LABELS,
} from "../lib/workshop-status";

export function WorkshopRegistrationsTable({
  items,
  onStatusChange,
  updatingId,
}: {
  items: Array<{
    id: string;
    fullName: string;
    nickname: string | null;
    phoneNumber: string;
    status: string;
    submittedAt: string;
    sessionLabels?: string[];
  }>;
  onStatusChange: (id: string, status: string) => void;
  updatingId?: string;
}) {
  return (
    <div className="overflow-x-auto rounded-lg border">
      <table className="w-full text-sm">
        <thead className="bg-muted/40 text-left">
          <tr>
            <th className="px-3 py-2 font-medium">ຊື່</th>
            <th className="px-3 py-2 font-medium">ເບີໂທ</th>
            <th className="px-3 py-2 font-medium">Workshop</th>
            <th className="px-3 py-2 font-medium">ສະຖານະ</th>
            <th className="px-3 py-2 font-medium">ວັນທີ່ສົ່ງ</th>
          </tr>
        </thead>
        <tbody>
          {items.map((row) => (
            <tr key={row.id} className="border-t">
              <td className="px-3 py-2">
                <div className="font-medium">{row.fullName}</div>
                {row.nickname ? (
                  <div className="text-muted-foreground text-xs">{row.nickname}</div>
                ) : null}
              </td>
              <td className="px-3 py-2">{row.phoneNumber}</td>
              <td className="px-3 py-2">
                <ul className="space-y-1 text-xs">
                  {(row.sessionLabels ?? []).map((label) => (
                    <li key={label}>{label}</li>
                  ))}
                </ul>
              </td>
              <td className="px-3 py-2">
                <select
                  className="rounded border bg-background px-2 py-1 text-xs"
                  value={row.status}
                  disabled={updatingId === row.id}
                  onChange={(e) => onStatusChange(row.id, e.target.value)}
                >
                  {Object.entries(WORKSHOP_REGISTRATION_STATUS_LABELS).map(
                    ([value, label]) => (
                      <option key={value} value={value}>
                        {label}
                      </option>
                    ),
                  )}
                </select>
              </td>
              <td className="text-muted-foreground px-3 py-2 text-xs">
                {row.submittedAt}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
